import DOMPurify from "isomorphic-dompurify";
import { Text } from 'lucide-react';
import * as React from "react";
import { Card } from '#app/components/ui/card';

interface StationDescriptionProps {
  description: string | null | undefined;
}

export function StationDescription({ description }: StationDescriptionProps) {
  if (!description) {
    return null;
  }

  // Sanitize the HTML description
  const sanitizedHtml = DOMPurify.sanitize(description);

  return (
    <Card className='overflow-hidden bg-white shadow-sm backdrop-blur-sm'>
      <div className='p-5'>
        <div className='mb-4 flex items-center gap-2'>
          <Text className='h-5 w-5 text-primary' />
          <h3 className='text-lg font-semibold'>Descrição</h3>
        </div>
        <article
          className="prose text-sm w-full max-w-none break-words px-1 text-foreground prose-a:text-blue-600 prose-strong:text-foreground dark:text-gray-300 dark:prose-a:text-blue-400 dark:prose-strong:text-gray-200"
          dangerouslySetInnerHTML={{
            __html: sanitizedHtml,
          }}
        />
      </div>
    </Card>
  );
}
